import React, { createContext, useContext, useState, useCallback } from "react";
import ne from "@/i18n/ne.json";
import en from "@/i18n/en.json";

const dict = { ne, en };
const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "ne");

  const toggleLang = useCallback(() => {
    setLang((prev) => {
      const next = prev === "ne" ? "en" : "ne";
      localStorage.setItem("lang", next);
      return next;
    });
  }, []);

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let node = dict[lang];
      for (const p of parts) {
        node = node?.[p];
        if (node === undefined) return path;
      }
      return node;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
